(ns bp-clients.tv-app.nav.views.loading
  "Namespace for loading navigation views"
  (:require [bp-libs.design-system.components.icons :refer [loading-spinner]]))

(defn loading
  "Loading nav view page."
  []
  [:main {:class "relative min-h-screen w-full bg-black"}
   [:div {:class "p-6"}
    [:section {:class "absolute top-1/2 left-1/2 mx-auto max-w-sm -translate-x-1/2 -translate-y-1/2 transform space-y-4 text-center"}
     [:div {:class "space-y-8 flex flex-col items-center animate-rotate"}
      [loading-spinner]]]]])
